<div class="container">
    <div class="title">{{ "payment.success.title" | translate }}</div>
    <div class="subtitle">
        {{ "payment.success.subtitle" | translate }}
    </div>
    <div class="subtitle">
        {{ "payment.success.fallback" | translate }}
    </div>
    <div class="button" (click)="redirect()">
        {{ "payment.success.backButton" | translate }}
    </div>
</div>
